<div id="imgmodel" bsModal #clientimgmodal="bs-modal" (onShown)="onShown()" class="modal right " tabindex="-1" role="dialog" aria-labelledby="projectimgmodal" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog-rignt ">
        <div class="row h-100">

            <div class="modal-content col">
                <div class="modal-header mb-1">
                    <div role="tablist">
                        <div class="card-title mr-10  mb-0 font-weight-boldest h4"> {{'UploadPhoto' | localize}}</div>

                    </div>
                    <button type="button" data-dismiss="modal" aria-label="Close" class="close mt-2" (click)="saveCancel()">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                  <div class="modal-body">
                    <div id="kt_widget2_tab1_content" class="tab-pane side-border mx-4" [class.active]="tabIndex == 1"
                         *ngIf="tabIndex == 1">
                        <div style="border: 1px solid #9EA4AC">
                            <div class="text-center mt-10">
                                <div *ngIf="showImgModal" class="image-input-wrapper">
                                    <img class="border-radius-2" *ngIf="imagePathModal != ''" [src]="imagePathModal">
                                    <img *ngIf="imagePathModal == '' " class="imgage-background" />

                                </div>
                                <div *ngIf="showImgModal">
                                    <label class="mt-3" (click)="removeImage()">
                                        <a class="blue cursor-pointer">
                                            {{'RemovePhoto' | localize}}
                                        </a>
                                    </label>
                                </div>
                                <div *ngIf="!showImgModal">
                                    <label class="mt-3 " title="">
                                        <input #fileInput type="file" id="UploadFile" style="display: none"
                                               (change)="getfileContent($event.target.files)" name="profile_avatar"
                                               accept=".png, .jpg, .jpeg" required>
                                        <a class="blue cursor-pointer font-size-h6">
                                            {{'ClickHere' | localize}}
                                        </a><br />
                                    </label>
                                    <div class="uploadPhoto font-size-h6 font-weight-bolder">{{"Touploadyourphoto" | localize}}</div>
                                    <br />
                                </div>
                            </div>
                            <div class="text-center mt-10">
                                <label class="font-size-sm font-weight-bold">{{"RecommendedFormat" | localize}}</label>
                            </div>
                            <div class="text-center">
                                <label class="font-size-sm font-weight-bold">{{"RecommendedSize" | localize}}</label>
                            </div>

                        </div>
                        <div class="col-md-12">
                            <div class="float-right mt-10">
                                <button class="btn btn-square btn-outline-danger px-5 mr-1" data-dismiss="clientimgmodal" (click)="saveCancel()">
                                    {{"Cancel" | localize}}
                                </button>
                                <button class="btn btn-square btn-primary px-8" data-dismiss="clientimgmodal" (click)="savePhoto()" [disabled]="isImage">
                                    {{"Upload" | localize}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div id="kt_widget2_tab1_content" class="tab-pane side-border" [class.active]="tabIndex == 2"
                         *ngIf="tabIndex == 2">
                        <div class="font-size-sm">
                            {{"Chooseanavatarforyourprofile" | localize}}
                        </div>
                        <div class="d-flex align-items-center flex-wrap">
                            <div *ngFor="let c of photoImage;let i = index; trackBy: trackByIndex"
                                 (click)="selectIcon(c.icon , i)" [ngClass]="{'highlight-avatar': selectedAvatarIndex === i}">
                                <img class="cursor-pointer mt-3 mr-2 avatar-icon-size" [src]="c.icon" [id]="'Img'+i">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="float-right mt-10">
                                <button class="btn btn-square btn-outline-danger px-5 mr-1" data-dismiss="clientimgmodal" (click)="saveCancel()">
                                    {{"Cancel" | localize}}
                                </button>
                                <button class="btn btn-square btn-primary btn-sm px-8" data-dismiss="clientimgmodal" (click)="savePhoto()"
                                [disabled]="isImage">
                                    {{"Upload" | localize}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<warning-modal #SignModalPopup message="Invalid Image Format ! " submessage="Please select png, jpg or jpeg format to upload image."></warning-modal>
